// extracted by mini-css-extract-plugin
export var button = "_e2-0";
export var icon = "_e2-1";